module.exports = __webpack_public_path__ + "8a93869306eb9c738c12e26774ed6c86.ico";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/favicon.ico
// module id = 307
// module chunks = 0